import api from "../../../services/axiosConfig";

export const getHistoryLogs = async () => {
  const response = await api.get("/history", {});
  return response.data.data.logs;
};
